
// From: https://2ality.com/2019/10/eval-via-import.html
export function esm(templateStrings: TemplateStringsArray, ...substitutions: unknown[]) {
  let js = templateStrings.raw[0];
  for (let i=0; i<substitutions.length; i++) {
    js += substitutions[i] + templateStrings.raw[i+1];
  }
  return 'data:text/javascript;base64,' + btoa(js);
}

// From: https://stackoverflow.com/a/19709846/4852536
export const absoluteUrl = new RegExp('^(?:[a-z+]+:)?//', 'i');

async function correctImportPaths(script: string): Promise<string> {
  // Import the babel JS parser
  const { parse } = await import('@babel/parser');
  // Parse the JS provided
  const ast = parse(script, { sourceType: 'module', createImportExpressions: true });
  // Traverse the AST and replace parts where we use ESM Imports
  const traverser = await import('@babel/traverse');
  traverser.default(ast, {
    ImportDeclaration: function(path) {
      // If we have an import declaration to a relative URL, then we need to replace it with an absolute one here
      // Relative URLs don't work in a `data:...` URI!
      if (!absoluteUrl.test(path.node.source.value)) {
        try {
          const newUrl = new URL(path.node.source.value, window.location.href).toString();
          console.debug(`[evaluateESM] Replaced ImportDeclaration`, path.node.source.value, '->', newUrl.toString());
          path.node.source.value = newUrl.toString();
        }
        catch {}
      }
    },
    ImportExpression: function(path) {
      // If we have an import declaration to a relative URL, then we need to replace it with an absolute one here
      // Relative URLs don't work in a `data:...` URI!
      if (path.node.source.type === 'StringLiteral' && !absoluteUrl.test(path.node.source.type)) {
        try {
          const newUrl = new URL(path.node.source.value, window.location.href).toString();
          console.debug(`[evaluateESM] Replaced ImportExpression`, path.node.source.value, '->', newUrl.toString());
          path.node.source.value = newUrl.toString();
        }
        catch {}
      }
    }
  })
  // Generate JS code from the modified AST
  const generator = await import('@babel/generator')
  const output = generator.default(ast);
  return output.code;
}

export async function evaluateESM(script: string) {
  const correctedCode = await correctImportPaths(script);

  //const dataURI = `data:application/javascript;base64,${btoa(script)}`;
  //const dataURI = `data:application/javascript;base64,${btoa(output.code)}`;
  return await import(/* @vite-ignore */`data:application/javascript;charset=utf-8,${encodeURIComponent(correctedCode)}`);
}
